var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.rows),function(row,index){return _c('div',{key:index,staticClass:"tile is-ancestor"},_vm._l((row),function(project,index2){return _c('div',{key:index2,staticClass:"tile"},[(project)?_c('project-card',{attrs:{"project":project}}):_vm._e()],1)}))}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9cbef336","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProjectCardList.vue
// module id = null
// module chunks = 